import{isTransform as r,asTransformCssVar as o,transformAlias as t}from"./transforms.es.js";function n(n){return t[n]&&(n=t[n]),r(n)?o(n):n}export{n as getStyleName};
